"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const MilestoneAwardManifest_1 = require("@/client/MilestoneAwardManifest");
const playerSymbol_1 = require("@/client/utils/playerSymbol");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'Milestone',
    props: {
        milestone: {
            type: Object,
            required: true,
        },
        showScores: {
            type: Boolean,
            default: true,
        },
        showDescription: {
            type: Boolean,
        },
    },
    methods: {
        playerSymbol(color) {
            return (0, playerSymbol_1.playerSymbol)(color);
        },
        getClass(score) {
            let classes = 'ma-score';
            classes += ` player_bg_color_${score.color}`;
            if (score.claimable) {
                classes += ' claimable';
            }
            else {
                classes += ' not-claimable';
            }
            return classes;
        },
    },
    computed: {
        name() {
            return this.milestone.name.replace(/[0-9]+$/, '');
        },
        nameCss() {
            return 'ma-name ma-name--' + this.milestone.name.replace(/ /g, '-').replace(/\./g, '').toLowerCase();
        },
        sortedScores() {
            return [...this.milestone.scores].sort((s1, s2) => s2.score - s1.score);
        },
        description() {
            return (0, MilestoneAwardManifest_1.getMilestone)(this.milestone.name).description;
        },
    },
});
